import React from "react";
import { useHistory } from "react-router-dom";
import { User } from "../../storage/store";
import AppDeviceCard from "./app/AppDeviceCard";
import { DEVICE_TYPES } from "../../constants/devices";

// Energy meters only report readings, so unlike SwitchCard there is no on/off
// toggle: clicking opens the detail page. As in the mobile app, the text stays
// black on the meter's light-blue fill.
const EnergyMeterCard = ({ props }) => {
  const device = props;
  const navigate = useHistory();

  return (
    <AppDeviceCard
      name={device.name}
      floor={device.floor}
      room={device.room}
      timeStamp={device.props?.timeStamp}
      type={DEVICE_TYPES.ENERGY_METER}
      active={Number(device.props?.state) === 1}
      darkText
      ariaLabel={`${device.name}, energy meter. Open readings`}
      onOpen={() =>
        navigate.push("/device", {
          data: device,
          propertyId: User.getPropertyId(),
        })
      }
    />
  );
};

export default EnergyMeterCard;
